export enum NewCardState {

    Collected = 'COLLECTED',
    NotCollected = 'NOT_COLLECTED'
}


export const newCardStates: { [ key: string ]: string } = { };

newCardStates[ NewCardState.Collected ] = 'Collected';
newCardStates[ NewCardState.NotCollected ] = 'Not Collected';



